module.exports = __webpack_public_path__ + "img/user-login.8e1b7436.svg";